// Comma-grouped display number for prices and credits — formatNumber(1234) → '1,234'
export const formatNumber = (value) => Number(value || 0).toLocaleString('en-US');
